import React from "react";
import "./about.css";
import "../../index.css";
import AboutPic from "../../assets/about2.png";
import { FaAward } from "react-icons/fa";
import { FaCode } from "react-icons/fa";
import { PiStudentBold } from "react-icons/pi";

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about_container">
        <div className="about_me">
          <div className="about_me_img">
            <img src={AboutPic} alt="About Image" className="about_pic" />
          </div>
        </div>

        <div className="about_content">
          <div className="about_cards">
            <article className="about_card">
              <FaAward className="about_icon" />
              <h5>Experience</h5>
              <small>1+ Years Working</small>
            </article>

            <article className="about_card">
              <PiStudentBold className="about_icon" />
              <h5>Education</h5>
              <small>B.Tech - Information Technology</small>
            </article>

            <article className="about_card">
              <FaCode className="about_icon" />
              <h5>Projects</h5>
              <small>10+ Projects Made</small>
            </article>
          </div>
          <p>
            Software engineer with 1+ year of experience. Currently working as
            an Associate Softaware Engineer at Nagarro specializing in React,
            Angular, Python, C#, JavaScript and SQL. Proven track record of
            effectively managing time to deliver successful projects. Proficient
            in working with databases and cloud infrastructure. Passionate about
            solving enterprise-level problems and contributing to new
            challenges.
          </p>

          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
